import {
  Button,
  Dialog,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";
import { MembershipAPI } from "../../api/membership";
import dayjs from "dayjs";
import { emailRegex } from "../constant";
import { useAppContext } from "../../context/AppContext";
import { NumericFormat } from "react-number-format";

const AddMemeberModal = ({ open, handleClose, setIsLoading }) => {
  const { openSnack } = useAppContext();
  const [formState, setFormState] = useState({
    first_name: "",
    last_name: "",
    company: "",
    chair: "",
    email_address: "",
    status: true,
    phone_number: "",
    date_started: "",
    membership_expiration_date: "",
    dues_paid: false,
    dues_paid_amount: "",
  });

  const [formError, setFormError] = useState({});

  const handleError = (formObj = formState) => {
    const temp = { ...formError };

    if ("first_name" in formObj) {
      temp.first_name = formObj.first_name ? "" : "This field is required.";
    }

    if ("last_name" in formObj) {
      temp.last_name = formObj.last_name ? "" : "This field is required.";
    }

    if ("company" in formObj) {
      temp.company = formObj.company ? "" : "This field is required.";
    }

    if ("chair" in formObj) {
      temp.chair = formObj.chair ? "" : "This field is required.";
    }

    if ("email_address" in formObj) {
      temp.email_address = formObj.email_address
        ? ""
        : "This field is required.";

      temp.email_address = !emailRegex?.test(formObj.email_address)
        ? "Please enter valid Email Address!"
        : "";
    }

    if ("phone_number" in formObj) {
      temp.phone_number = formObj.phone_number ? "" : "This field is required.";
    }

    if ("date_started" in formObj) {
      temp.date_started = formObj.date_started ? "" : "This field is required.";
    }

    if ("dues_paid_amount" in formObj) {
      temp.dues_paid_amount = formObj.dues_paid_amount
        ? ""
        : "This field is required.";
    }

    setFormError({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleChange = (key, value) => {
    setFormState((prevState) => ({ ...prevState, [key]: value }));
    handleError({ [key]: value });
  };

  const renderForm = () => {
    return (
      <Grid
        container
        spacing={2}
        rowSpacing={2.5}
        sx={{
          padding: "16px 0",
        }}
      >
        <Grid item xs={12} sm={6}>
          {" "}
          <TextField
            margin="normal"
            fullWidth
            id="first_name"
            label="First Name*"
            name="first_name"
            value={formState?.first_name}
            onChange={(e) => handleChange("first_name", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.first_name}
            helperText={formError.first_name}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {" "}
          <TextField
            margin="normal"
            fullWidth
            id="last_name"
            label="Last Name*"
            name="last_name"
            value={formState?.last_name}
            onChange={(e) => handleChange("last_name", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.last_name}
            helperText={formError.last_name}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          {" "}
          <TextField
            margin="normal"
            fullWidth
            id="company"
            label="Company*"
            name="company"
            value={formState?.company}
            onChange={(e) => handleChange("company", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.company}
            helperText={formError.company}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {" "}
          <TextField
            margin="normal"
            fullWidth
            id="chair"
            label="Chair*"
            name="chair"
            value={formState?.chair}
            onChange={(e) => handleChange("chair", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.chair}
            helperText={formError.chair}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {" "}
          <TextField
            margin="normal"
            fullWidth
            id="email_address"
            label="Email Address*"
            name="email_address"
            value={formState?.email_address}
            onChange={(e) => handleChange("email_address", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.email_address}
            helperText={formError.email_address}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {" "}
          <TextField
            margin="normal"
            fullWidth
            id="phone_number"
            label="Phone Number*"
            name="phone_number"
            value={formState?.phone_number}
            onChange={(e) => handleChange("phone_number", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.phone_number}
            helperText={formError.phone_number}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="status"
            label="Status*"
            name="status"
            value={formState?.status}
            onChange={(e) => handleChange("status", e.target.value)}
            className="login-textField "
            size="small"
            error={!!formError.status}
            helperText={formError.status}
            select
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6}>
          <DatePicker
            label="Date Started*"
            value={formState?.date_started || null}
            onChange={(newValue) => handleChange("date_started", newValue)}
            className="login-textField date-textField"
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                margin: "normal",
                fullWidth: true,
                id: "date_started",
                name: "date_started",
                className: "login-textField",
                size: "small",
                error: !!formError.date_started,
                helperText: formError.date_started,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="normal"
            fullWidth
            id="membership_expiration_date"
            label="Membership Expiration Date*"
            name="membership_expiration_date"
            value={
              formState?.date_started
                ? dayjs(formState.date_started)
                    .add(1, "year")
                    .format("MM/DD/YYYY")
                : ""
            }
            className="login-textField"
            size="small"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl component="fieldset" variant="standard" className="mt-6">
            <FormGroup>
              <FormControlLabel
                className="gap-4"
                control={
                  <Switch
                    checked={formState?.dues_paid}
                    onChange={(e) =>
                      handleChange("dues_paid", e.target.checked)
                    }
                    name="dues_paid"
                    className="switchStyles"
                  />
                }
                label="Dues Paid*"
              />
            </FormGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <NumericFormat
            value={formState?.dues_paid_amount}
            onValueChange={(e) => handleChange("dues_paid_amount", e.value)}
            customInput={TextField}
            thousandSeparator
            valueIsNumericString
            fixedDecimalScale
            decimalScale={2}
            prefix="$"
            label="Dues Paid Amount*"
            className="login-textField"
            error={!!formError.dues_paid_amount}
            helperText={formError.dues_paid_amount}
            size="small"
          />
        </Grid>
      </Grid>
    );
  };

  const addNewMember = async (form) => {
    const member = {
      ...form,
      dues_paid_amount: form.dues_paid_amount * 1,
      date_started: dayjs(form.date_started).format("YYYY-MM-DD"),
      membership_expiration_date: dayjs(formState.date_started)
        .add(1, "year")
        .format("YYYY-MM-DD"),
    };

    try {
      await MembershipAPI.addMember(member);
      openSnack("Member added successfully.", "success");
      setIsLoading(true);
      handleClose();
    } catch (error) {
      console.error("Error adding member:", error);
    }
  };

  const handleSubmit = () => {
    if (handleError()) {
      addNewMember(formState);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-modal"
      sx={{
        ".MuiPaper-root": {
          maxWidth: "706px",
          maxHeight: "550px",
          margin: "16px",
        },
      }}
    >
      <div className="modal-header">
        <h2 className="header-text">Create New Member</h2>
        <IconButton onClick={() => handleClose()}>
          <GridCloseIcon />
        </IconButton>
      </div>
      <Stack
        sx={{
          height: "400px",
          overflowY: "scroll",
        }}
      >
        {renderForm()}
      </Stack>

      <DialogActions
        sx={{ paddingTop: "8px", background: "#fff", zIndex: 2 }}
        className="modal-btn-container"
      >
        <Button onClick={handleClose} className="button-common light-blue-bg">
          Cancel
        </Button>
        <Button onClick={handleSubmit} className="add-new-button button-common">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddMemeberModal;
